import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { IconFilter } from '../../../components';

import css from './SearchFiltersPrimary.module.css';

const SearchFiltersPrimaryComponent = props => {
  const {
    rootClassName,
    className,
    isSecondaryFiltersOpen = false,
    toggleSecondaryFiltersOpen = null,
    selectedSecondaryFiltersCount = 0,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  const filtersButton = toggleSecondaryFiltersOpen ? (
    <button
      className={classNames(css.filtersButton, {
        [css.filtersButtonActive]: isSecondaryFiltersOpen || selectedSecondaryFiltersCount > 0,
      })}
      type="button"
      onClick={() => toggleSecondaryFiltersOpen(!isSecondaryFiltersOpen)}
    >
      <IconFilter />
      <FormattedMessage id="SearchFiltersPrimary.filtersButton" />
    </button>
  ) : null;

  return (
    <div className={classes}>
      {filtersButton}
    </div>
  );
};

const SearchFiltersPrimary = SearchFiltersPrimaryComponent;

export default SearchFiltersPrimary;
